import {
  SET_DATE_RANGE,
  SET_RECRUITER_DATA,
  RESET_RECRUITER_DATA,
  SET_RECRUITER_FILTERS,
  RESET_ALL_DATA,
  SET_SELECTED_FILTERS,
  RESET_SELECTED_FILTERS,
  SET_WISHLISTED_PROFILES,
  SET_RECRUITER_ACCESS_TOKEN,
  SET_RECRUITER_UUID,
  SET_RECRUITER_AUTH_DATA,
  SET_RECRUITER_PUBLIC_NL_SEARCH_USED,
} from "../actions/types";

const initialState = {
  dateRange: null,
  recruiterPublicNlSearchUsed: false,
  recruiterAccessToken: null,
  recruiterUUID: null,
  recruiterData: null,
  recruiterAuthData: null,
  recruiterFilters: null,
  wishlistedProfiles: [],
  selectedFilters: {
    companies: [],
    institutions: [],
    states: [],
    cities: [],
    skills: [],
    experience: [],
    nlQueryFilters: [],
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DATE_RANGE:
      return { ...state, dateRange: action.payload };
    case SET_RECRUITER_ACCESS_TOKEN:
      return { ...state, recruiterAccessToken: action.payload };
    case SET_RECRUITER_UUID:
      return { ...state, recruiterUUID: action.payload };
    case SET_RECRUITER_DATA:
      return { ...state, recruiterData: action.payload };
    case SET_RECRUITER_AUTH_DATA:
      return { ...state, recruiterAuthData: action.payload };
    case SET_RECRUITER_PUBLIC_NL_SEARCH_USED:
      return { ...state, recruiterPublicNlSearchUsed: action.payload };
    case SET_RECRUITER_FILTERS:
      return { ...state, recruiterFilters: action.payload };
    case SET_WISHLISTED_PROFILES:
      return { ...state, wishlistedProfiles: action.payload };
    case SET_SELECTED_FILTERS:
      return {
        ...state,
        selectedFilters: { ...state.selectedFilters, ...action.payload },
      };
    case RESET_SELECTED_FILTERS:
      return {
        ...state,
        selectedFilters: {
          companies: [],
          institutions: [],
          states: [],
          cities: [],
          skills: [],
          experience: [],
        },
      };
    case RESET_RECRUITER_DATA:
      return { ...state, recruiterData: null };
    case RESET_ALL_DATA:
      return { ...state, ...initialState };
    default:
      return state;
  }
}
